import { registerLocale, setDefaultLocale } from "react-datepicker";
import { setDefaultOptions } from "date-fns";
import dateLocaleES from "date-fns/locale/es";

setDefaultOptions({ locale: dateLocaleES });
registerLocale("es", dateLocaleES);
setDefaultLocale("es");
